import React from 'react';
import { useTranslation } from 'react-i18next';
import SystemNotification from '../../../../SystemNotification/SystemNotification';
import { Notification } from '../../../../Notifications';
const LabelAsNotification = ({ id, queueName, deviationIds, folderName, label, value })=>{
    const { t } = useTranslation();
    const labelName = t(`mediapopup.notifications.labelAs.label.${label}`);
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        cardProps: {
            limitTextWidth: false
        }
    }, t(`mediapopup.notifications.labelAs.${deviationIds && deviationIds.length ? 'selectedDeviations' : 'selectedFolder'}.value.${value}`, {
        labelName,
        folderName
    }));
};
LabelAsNotification.displayName = 'LabelAsNotification';
export default LabelAsNotification;
